<script lang="ts">
    import { disabled } from "$/utils/disabled";
    import { createEventDispatcher } from "svelte";
    export let snippetCount;

    const dispatch = createEventDispatcher();
</script>

<div class="pdf-recent-delete-dialog">
    <div class="pdf-recent-delete-dialog__content">
        <p class="pdf-recent-delete-dialog__text">
            {#if snippetCount === undefined || snippetCount === null}
                <span class="pdf-recent-delete-dialog__loader"></span>
                <span>Loading document & snippets information...</span>
            {:else if snippetCount === 0}
                <span>
                    Deleting this document will not affect any snippets.
                </span>
            {:else}
                <span>
                    Deleting this document will <b class="font-bold">disable</b> locate functionality on
                    <b class="font-bold">{snippetCount} snippet{snippetCount === 1 ? "" : "s"}</b>
                </span>
            {/if}
        </p>
    </div>

    <div class="pdf-recent-delete-dialog__actions">
        <button
            class="pdf-recent-delete-dialog__delete"
            use:disabled={{
                isDisabled: snippetCount === undefined || snippetCount === null,
                message: "Document still loading",
            }}
            on:click|preventDefault|stopPropagation={() =>
                dispatch("confirmDelete")}
        >
            Delete
        </button>

        <button
            class="pdf-recent-delete-dialog__cancel"
            on:click|preventDefault|stopPropagation={() =>
                dispatch("cancelDelete")}
        >
            Cancel
        </button>
    </div>
</div>

<style>
    .pdf-recent-delete-dialog {
        @apply flex gap-2 flex-col sm:flex-row items-center justify-between rounded-3xl sm:rounded-full bg-pink-100 p-2;
    }
    .pdf-recent-delete-dialog__content {
        @apply px-2 text-xs text-gray-800;
    }
    .pdf-recent-delete-dialog__actions {
        @apply flex h-full max-h-full gap-1 text-xs;
    }
    .pdf-recent-delete-dialog__actions button {
        @apply cursor-pointer rounded-sm border-none px-2 py-1 no-underline focus:outline-none;
    }
    .pdf-recent-delete-dialog__delete {
        @apply font-bold text-pink-500 hover:bg-pink-200;
    }
    .pdf-recent-delete-dialog__delete:disabled {
        @apply cursor-not-allowed text-pink-400 hover:bg-transparent;
    }
    .pdf-recent-delete-dialog__cancel {
        @apply font-normal text-black hover:bg-pink-200;
    }
    .pdf-recent-delete-dialog__text {
        @apply flex items-center text-center sm:text-left;
    }
    .pdf-recent-delete-dialog__loader {
        @apply box-border inline-block h-6 w-6 animate-spin rounded-full border-2 border-b-[3px] border-gray-100 border-b-pink-500;
    }
</style>
